import { circleHref } from "../../routes";

/** What another page hands a Circle's page in router state: a User to start adding, by id. */
export type CircleHandover = { addUser?: string };

/** A Circle's router state, read on arrival; anything else is no handover. */
export const readCircleHandover = (state: unknown): CircleHandover => {
  const { addUser } = (state ?? {}) as CircleHandover;
  return typeof addUser === "string" && addUser ? { addUser } : {};
};

export const toCircle = (circleId: string, handover: CircleHandover = {}) => ({
  pathname: circleHref(circleId),
  state: handover,
});
